import { render } from "./MarketSortBar.vue?vue&type=template&id=8e8ec65c&scoped=true"
import script from "./MarketSortBar.vue?vue&type=script&lang=js"
export * from "./MarketSortBar.vue?vue&type=script&lang=js"

import "./MarketSortBar.vue?vue&type=style&index=0&id=8e8ec65c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e8ec65c"]])

export default __exports__